import React from "react";
import { NouvelleFenetre } from "../../../../components/common/NouvelleFenetre";

export const Modal = ({mediaData, onClose}) => {

    return (
        <div id="media-modal" className={mediaData ? 'show' : ''}>
            { mediaData &&
                <div className="modal-content large">
                    <div className="modal-header">
                        <p>{mediaData.title}</p>
                        <button type="button" onClick={onClose}>x</button>
                    </div>
                    <div className="modal-body">
                        {mediaData.type === 'img' ?
                            <a href={mediaData.src} target="_blank" rel="noreferrer noopener" className="img-media">
                                <img
                                    src={mediaData.thumbnail ? mediaData.thumbnail : mediaData.src}
                                    alt={mediaData.title}
                                    title={`${mediaData.title} (nouvelle fenêtre)`}
                                />
                                <NouvelleFenetre/>
                            </a>
                            :
                            mediaData.type === 'video' ?
                                <iframe
                                    src={mediaData.src}
                                    title={mediaData.title}
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    referrerpolicy="strict-origin-when-cross-origin" allowFullScreen>
                                </iframe>
                            :
                            <iframe src={mediaData.src} title={mediaData.title}></iframe>
                        }
                    </div>
                    <div className="modal-footer">
                        {mediaData.source && <p>Source : <a href={mediaData.source.url} target="_blank" rel="noreferrer noopener">{mediaData.source.name}<NouvelleFenetre/></a></p>}
                    </div>
                </div>
            }
        </div>
    )
}